import React from 'react';

import { StockSymbol } from '@benzinga/session';
import { getQuoteChange, Quote } from '@benzinga/quotes-manager';
import { isNil } from '@benzinga/utils';
import { NO_VALUE } from './info';
import { PerformanceColor } from './PerformanceColor';
import { useQuoteSubscription } from '@benzinga/quotes-manager-hooks';

export type QuoteValueProperty = 'change' | 'percentChange';

interface QuoteValueProps {
  options?: Options;
  quoteProperty: QuoteValueProperty;
  symbol: StockSymbol;
}

interface Options {
  formatter?(value: number): string;
}

export const QuoteValue: React.FC<QuoteValueProps> = props => {
  const { quote } = useQuoteSubscription(props.symbol);

  const { nominalChange: change, percentageChange: percentChange } = getQuoteChange<Quote>(quote);

  const value = { change, percentChange }[props.quoteProperty];

  const formattedValue = isNil(value)
    ? NO_VALUE
    : props.options?.formatter
      ? props.options.formatter(value)
      : String(value);

  return <PerformanceColor label={formattedValue} stat={value} />;
};
